import { Component, OnInit } from '@angular/core';
import { ModulesManagerService } from 'src/app/classes/Module/modules-manager.service';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent implements OnInit {
  public manager: ModulesManagerService
  
  constructor(manager : ModulesManagerService) { 
    this.manager = manager
  }

  ngOnInit() {}

  public getSelectedClass(page: string) {
    if(!this.manager.Navi.isSelected(page)) return ''
    return 'footerSelected'
  }

}
